import { c as _c } from "react/compiler-runtime";
import { range } from "es-toolkit/math";
import { SkeletonBlock } from "../Skeleton";
import { TextBodySkeleton } from "../Text/TextBody";
import { Timeline, TimelineAvatar, TimelineContent, TimelineItem } from "./Timeline";
export const TimelineSkeleton = t0 => {
  const $ = _c(5);
  const {
    className,
    count: t1
  } = t0;
  const count = t1 === undefined ? 2 : t1;
  let t2;
  if ($[0] !== count) {
    t2 = range(count).map(_temp);
    $[0] = count;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== className || $[3] !== t2) {
    t3 = <Timeline className={className}>{t2}</Timeline>;
    $[2] = className;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
function _temp(i) {
  return <TimelineItem active={true} key={i}><TimelineAvatar><SkeletonBlock /></TimelineAvatar><TimelineContent><TextBodySkeleton className="w-40" size="sm" /></TimelineContent></TimelineItem>;
}